<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :tables="pageData"
      :isFooter="isFooter"
      :isExpansionPanelFooter="isHistoryType"
    >
      <template v-slot:[pageData[0].name]>
        <ClientInfo
          :recItems="recItems"
          :pageType="isHistoryType ? 'history' : 'register'"
        />
      </template>
      <template v-slot:[pageData[1].name]>
        <ProductTable
          :headers="pageData[1].headers"
          :items="recItems.productMoves"
          item-key="product.productNumber"
          productKey="productMoveId"
        >
        </ProductTable>
      </template>
      <template #expansionPanelFooter1>
        <v-container fluid>
          <v-row justify="end" class="ma-1">
            <div class="ma-2 btnStyle">
              <NormalButton
                v-if="authority.isAdmin"
                :text="$t('storage.storage_storage-move-cancel')"
                textSize="12px"
                height="32px"
                width="100%"
                btnClass="ml-auto"
                color="white"
                textColor="thinText--text"
                @click="cancel"
                :outlined="true"
              />
            </div>
            <div class="ma-2 ml-6 btnStyle">
              <NormalButton
                :text="$t('storage.storage_storage-move-adjust')"
                textSize="12px"
                height="32px"
                width="100%"
                btnClass="ml-auto"
                color="white"
                textColor="thinText--text"
                :outlined="true"
                @click="quickFix.dialog = true"
              />
              <QuickFixStockMoveDialog
                v-model="quickFix"
                :text="$t('storage.storage_storage-move-adjust')"
                width="80%"
                :recItems="recItems"
                @dialogReload="dialogReload"
              />
            </div>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[2].name]>
        <v-row class="mx-3 my-2">
          <v-col cols="6">
            <Remarks
              title=""
              text=""
              v-model="remarks"
              :isRegister="isHistoryType"
              @updateRemarks="updateRemarks"
            />
          </v-col>
        </v-row>
      </template>

      <template #footer>
        <slot name="footer" />
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MultipleAreaBase from '../MultipleAreaBase'

import ClientInfo from '@/components/layouts/ClientConfirmation/StockMoveInfo/CustomerInfoBase'
import { ProductTable, Remarks } from '@/components/items'
import { QuickFixStockMoveDialog } from '@/components/layouts/Dialogs'

import NormalButton from '@/components/items/Buttons/NormalButton'

export default {
  components: {
    MultipleAreaBase,
    ClientInfo,
    // OperationDetail,
    ProductTable,
    Remarks,
    NormalButton,
    QuickFixStockMoveDialog
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    },

    pageData: {
      type: Array,
      require: true,
      default: () => []
    },

    isHistoryType: { default: false },
    isFooter: { default: false },
    isEdit: { default: false },
    isTotalAmount: { default: true }
  },
  data: () => ({
    pageType: {
      en: 'sale',
      ja: '注文'
    },
    quickFix: { dialog: false },

    remarks: ''
  }),
  methods: {
    // register() {
    //   this.$emit('register')
    // },
    cancel() {
      this.$emit('cancel', this.recItems.storageMoveId)
    },
    updateRemarks(text) {
      this.$emit('updateRemarks', this.recItems.storageMoveId, text)
    },
    dialogReload() {
      this.$emit('dialogReload')
    },
    setDefaultRemarks() {
      if (!this.recItems.storageMoveNote) {
        this.remarks = ''
        return
      }
      this.remarks = this.recItems.storageMoveNote.body
    }
    // edit(rec) {
    //   this.$emit('edit')
    // }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    remarks: {
      deep: true,
      handler(newVal, oldVal) {
        if (!this.isHistoryType) this.$emit('editRemarks', newVal)
      }
    },
    recItems: {
      handler(newVal, oldVal) {
        this.setDefaultRemarks()
      },
      deep: true,
      immediate: true
    },
    'inputedValue.dialog': async function (val) {
      // val ? await this.ini() : null
    }
  }
}
</script>
<style lang="scss" scoped>
// .productTableCom {
//   ::v-deep .v-data-table th {
//     background-color: rgba(151, 198, 234, 0.1);
//     padding-left: 30px;
//   }
//   ::v-deep .v-data-table td {
//     padding-left: 30px;
//   }
// }
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 133px;
}
</style>
